const VERTICAL_TRAVERSAL_CATEGORY = [
  "elevator",
  "escalator",
  "stairs",
  "stairs.emergencyexit",
  "ramp",
]
const VERTICAL_KIOSK_BREAKPOINT = "@media (min-height:1920px)"

const Q_AUTOPLAY = "autoplay"
const Q_QUERY = "q"
const Q_MODE = "mode"
const SEARCH_MODE_STORES = "stores"
const SEARCH_MODE_PARKING = "parking"
const DEFAULT_SEARCH_MODE = SEARCH_MODE_STORES
const Q_SEARCH = "search"
const Q_SEARCH_CATEGORY_ID = "searchCategoryId"
const Q_PARENT_CATEGORY_ID = "parentCategoryId"
const Q_EVENT_GROUP = "group"
const Q_PROMOTION_GROUP = "group"
const Q_SUB_CATEGORY_ID = "subCategoryId"
const Q_ORDINAL = "ordinal"
const Q_FROM_ORDINAL = "from-ordinal"
const Q_VENUE = "venue"
const Q_SECTION_CORRELATION_ID = "section_correlation_id"
const Q_MAP_VIEW = "mv"
const Q_VIEW_MODE = "view-mode"
const Q_USER_LOCATION = "user-location"

const PROMOTION_TAXONOMY = "promotion-category"
const LOCAL_SECTION_CATEGORY = "local-section-category"

const DINING_TAXONOMY_TAG = "dining"

const GTM_SEARCH_KEYWORD = "search_keyword"
const GTM_CATEGORY_QUICK_SEARCH = "category_quick_search"
const GTM_GET_DIRECTION = "get_direction"
const GTM_VIEW_EVENT_DETAIL = "view_event_detail"
const GTM_VIEW_POST_DETAIL = "view_post_detail"
const GTM_AMENITY_SEARCH = "amenity_search"
const GTM_VIEW_PROMOTION_DETAIL = "view_promotion_detail"
const GTM_VIEW_FEATURE_DETAIL = "view_feature_detail"
const GTM_VIEW_DIRECTORY_CATEGORY = "view_directory_category"
const GTM_NO_RESULT_VALUE = "no result"
const GTM_PROMOTION_LOCATION = "view_promotion_location"
const GTM_EVENT_LOCATION = "view_event_location"
const GTM_POST_LOCATION = "view_post_location"
const GTM_VIEW_DINING_CATEGORY = "view_dining_category"
const GTM_COUNT_KIOSK_USERS = "count_kiosk_users"
const GTM_SURVEY_NEW_SESSION = "survey_new_session"
const GTM_SURVEY_NAVIGATION_EXPERIENCE = "survey_navigation_experience"
const GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE =
  "survey_navigation_experience_incomplete"
const GTM_SELECT_LANGUAGE = "select_language"
const GTM_VIEW_POST = "view_post"
const GTM_VIEW_SERVICE = "view_service"
const GTM_VIEW_RESERVATION = "view_reservation"
const GTM_VIEW_RECOMMENDED_MENU = "view_recommended_menu"
const GTM_SELECT_SEARCH_MODE = "select_search_mode"
const GTM_SELECT_PARKING_RESULT = "select_parking_result"
const GTM_SET_PARKING = "set_parking"
const GTM_CONFIRM_PARKING = "confirm_parking"
const GTM_REQUEST_CLEAR_PARKING = "request_clear_parking"
const GTM_CLEAR_PARKING = "clear_parking"
const GTM_VIEW_SAVED_PARKING = "view_saved_parking"
const GTM_OPEN_AI_ASSISTANT = "open_ai_assistant"

const DEVICE_MOBILE = "mobile"
const DEVICE_KIOSK_V = "kiosk-v"
const DEVICE_KIOSK_H = "kiosk-h"

const HOMEPAGE_ANIMATION = "homepage-animation"

const SHOP_PROMOTION_VIEW_MODE = "shop"

const DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY = [
  "categoryText",
  "floorText",
  "groupText",
]

const DEFAULT_FILTER_VALUE = "ALL"
const DEFAULT_VENUE_FILTER = DEFAULT_FILTER_VALUE

const UPCOMING_EVENT_FILTER_VALUE = "upcoming"
const CURRENT_EVENT_FILTER_VALUE = "current"
const DEFAULT_EVENT_FILTER_VALUE = CURRENT_EVENT_FILTER_VALUE

const UPCOMING_PROMOTION_FILTER_VALUE = "upcoming"
const CURRENT_PROMOTION_FILTER_VALUE = "current"
const DEFAULT_PROMOTION_FILTER_VALUE = CURRENT_PROMOTION_FILTER_VALUE

const DEFAULT_FILTER_OPTIONS = {
  sanitizeValues: [DEFAULT_FILTER_VALUE],
}

const SKELETON_COUNT = 5
const SKELETON_INDEX_TO_REF = SKELETON_COUNT - 1

const MAP_DEFAULT_BEARING_KEY = "map_default_bearing"
const MAP_DEFAULT_ZOOM_KEY = "map_default_zoom"
const MAP_DEFAULT_PITCH_KEY = "map_default_pitch"
const FORCE_VENUE_ID_KEY = "force_venue_id"

const ERROR_STRATEGY = {
  REDIRECT_404: "redirect_404",
  RELOAD: "reload",
  DIALOG: "dialog",
}

const PROMOTION_PAGE_CONFIG = "promotion"
const EVENT_PAGE_CONFIG = "event"
const DIRECTORY_PAGE_CONFIG = "directory"
const DINING_PAGE_CONFIG = "dining"

// Local Storage keys
const VENUE_DEVICE_NAME_KEY = "venue_device_name"
const KIOSK_CONFIG_NAME_KEY = "kiosk_config_name"

export {
  // Query String
  Q_SEARCH,
  Q_QUERY,
  Q_MODE,
  Q_AUTOPLAY,
  Q_PARENT_CATEGORY_ID,
  Q_SEARCH_CATEGORY_ID,
  Q_SUB_CATEGORY_ID,
  Q_ORDINAL,
  Q_FROM_ORDINAL,
  Q_VENUE,
  Q_SECTION_CORRELATION_ID,
  Q_MAP_VIEW,
  Q_VIEW_MODE,
  Q_EVENT_GROUP,
  Q_PROMOTION_GROUP,
  Q_USER_LOCATION,
  // Google Analytics
  GTM_SEARCH_KEYWORD,
  GTM_CATEGORY_QUICK_SEARCH,
  GTM_GET_DIRECTION,
  GTM_VIEW_EVENT_DETAIL,
  GTM_VIEW_POST_DETAIL,
  GTM_AMENITY_SEARCH,
  GTM_VIEW_PROMOTION_DETAIL,
  GTM_VIEW_FEATURE_DETAIL,
  GTM_VIEW_DIRECTORY_CATEGORY,
  GTM_NO_RESULT_VALUE,
  GTM_PROMOTION_LOCATION,
  GTM_EVENT_LOCATION,
  GTM_POST_LOCATION,
  GTM_VIEW_DINING_CATEGORY,
  GTM_COUNT_KIOSK_USERS,
  GTM_SURVEY_NEW_SESSION,
  GTM_SURVEY_NAVIGATION_EXPERIENCE,
  GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE,
  GTM_SELECT_LANGUAGE,
  GTM_VIEW_POST,
  GTM_VIEW_SERVICE,
  GTM_VIEW_RESERVATION,
  GTM_VIEW_RECOMMENDED_MENU,
  GTM_SELECT_SEARCH_MODE,
  GTM_SELECT_PARKING_RESULT,
  GTM_SET_PARKING,
  GTM_CONFIRM_PARKING,
  GTM_REQUEST_CLEAR_PARKING,
  GTM_CLEAR_PARKING,
  GTM_VIEW_SAVED_PARKING,
  GTM_OPEN_AI_ASSISTANT,
  // Pages
  HOMEPAGE_ANIMATION,
  SHOP_PROMOTION_VIEW_MODE,
  // Search modes
  SEARCH_MODE_STORES,
  SEARCH_MODE_PARKING,
  DEFAULT_SEARCH_MODE,
  // Filters
  DEFAULT_VENUE_FILTER,
  DEFAULT_FILTER_VALUE,
  DEFAULT_FILTER_OPTIONS,
  UPCOMING_EVENT_FILTER_VALUE,
  CURRENT_EVENT_FILTER_VALUE,
  DEFAULT_EVENT_FILTER_VALUE,
  UPCOMING_PROMOTION_FILTER_VALUE,
  CURRENT_PROMOTION_FILTER_VALUE,
  DEFAULT_PROMOTION_FILTER_VALUE,
  // Page Configs
  PROMOTION_PAGE_CONFIG,
  EVENT_PAGE_CONFIG,
  DIRECTORY_PAGE_CONFIG,
  DINING_PAGE_CONFIG,
  // Local Storage
  VENUE_DEVICE_NAME_KEY,
  KIOSK_CONFIG_NAME_KEY,
  // Others
  DEVICE_MOBILE,
  DEVICE_KIOSK_V,
  DEVICE_KIOSK_H,
  DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY,
  PROMOTION_TAXONOMY,
  LOCAL_SECTION_CATEGORY,
  VERTICAL_TRAVERSAL_CATEGORY,
  VERTICAL_KIOSK_BREAKPOINT,
  SKELETON_COUNT,
  SKELETON_INDEX_TO_REF,
  MAP_DEFAULT_BEARING_KEY,
  MAP_DEFAULT_ZOOM_KEY,
  MAP_DEFAULT_PITCH_KEY,
  FORCE_VENUE_ID_KEY,
  ERROR_STRATEGY,
  DINING_TAXONOMY_TAG,
}
